import {createPage} from 'app/client/ui/createPage';
import {LoginPages} from 'app/client/ui/LoginPages';
import {dom} from 'grainjs';

createPage(() => dom.create(LoginPages));
